import type { Spell } from '@character-creator/types';

export const level9Spells: Spell[] = [
  {
    id: 'astral-projection',
    name: 'Astral Projection',
    level: 9,
    school: 'necromancy',
    ritual: false,
    castingTime: '1 hour',
    range: '10 feet',
    components: { verbal: true, somatic: true, material: true, materialDescription: 'for each creature you affect with this spell, you must provide one jacinth worth at least 1,000 gp and one ornately carved bar of silver worth at least 100 gp, all of which the spell consumes', materialCost: 1100, materialConsumed: true },
    duration: 'Special',
    concentration: false,
    description: "You and up to eight willing creatures within range project your astral bodies into the Astral Plane (the spell fails and the casting is wasted if you are already on that plane). The material body you leave behind is unconscious and in a state of suspended animation, it doesn't need food or air and doesn't age. Your astral body resembles your mortal form in almost every way, replicating your game statistics and possessions. The principal difference is the addition of a silvery cord that extends from between your shoulder blades and trails behind you, fading to invisibility after 1 foot.",
    classes: ['cleric', 'warlock', 'wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'foresight',
    name: 'Foresight',
    level: 9,
    school: 'divination',
    ritual: false,
    castingTime: '1 minute',
    range: 'Touch',
    components: { verbal: true, somatic: true, material: true, materialDescription: 'a hummingbird feather' },
    duration: '8 hours',
    concentration: false,
    description: "You touch a willing creature and bestow a limited ability to see into the immediate future. For the duration, the target can't be surprised and has advantage on attack rolls, ability checks, and saving throws. Additionally, other creatures have disadvantage on attack rolls against the target for the duration. This spell immediately ends if you cast it again before its duration ends.",
    classes: ['bard', 'druid', 'warlock', 'wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'gate',
    name: 'Gate',
    level: 9,
    school: 'conjuration',
    ritual: false,
    castingTime: '1 action',
    range: '60 feet',
    components: { verbal: true, somatic: true, material: true, materialDescription: 'a diamond worth at least 5,000 gp', materialCost: 5000 },
    duration: '1 minute',
    concentration: true,
    description: "You conjure a portal linking an unoccupied space you can see within range to a precise location on a different plane of existence. The portal is a circular opening, which you can make 5 to 20 feet in diameter. You can orient the portal in any direction you choose. The portal lasts for the duration. The portal has a front and a back on each plane where it appears. Travel through the portal is possible only by moving through its front. Anything that does so is instantly transported to the other plane, appearing in the unoccupied space nearest to the portal.",
    classes: ['cleric', 'sorcerer', 'wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'imprisonment',
    name: 'Imprisonment',
    level: 9,
    school: 'abjuration',
    ritual: false,
    castingTime: '1 minute',
    range: '30 feet',
    components: { verbal: true, somatic: true, material: true, materialDescription: 'a vellum depiction or a carved statuette in the likeness of the target, and a special component that varies according to the version of the spell you choose, worth at least 500 gp per Hit Die of the target', materialCost: 500 },
    duration: 'Until dispelled',
    concentration: false,
    description: "You create a magical restraint to hold a creature that you can see within range. The target must succeed on a Wisdom saving throw or be bound by the spell; if it succeeds, it is immune to this spell if you cast it again. While affected by this spell, the creature doesn't need to breathe, eat, or drink, and it doesn't age. Divination spells can't locate or perceive the target. When you cast the spell, you choose one of the following forms of imprisonment.",
    classes: ['warlock', 'wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'mass-heal',
    name: 'Mass Heal',
    level: 9,
    school: 'evocation',
    ritual: false,
    castingTime: '1 action',
    range: '60 feet',
    components: { verbal: true, somatic: true, material: false },
    duration: 'Instantaneous',
    concentration: false,
    description: "A flood of healing energy flows from you into injured creatures around you. You restore up to 700 hit points, divided as you choose among any number of creatures that you can see within range. Creatures healed by this spell are also cured of all diseases and any effect making them blinded or deafened. This spell has no effect on undead or constructs.",
    classes: ['cleric'],
    source: 'srd-5.1',
  },
  {
    id: 'meteor-swarm',
    name: 'Meteor Swarm',
    level: 9,
    school: 'evocation',
    ritual: false,
    castingTime: '1 action',
    range: '1 mile',
    components: { verbal: true, somatic: true, material: false },
    duration: 'Instantaneous',
    concentration: false,
    description: "Blazing orbs of fire plummet to the ground at four different points you can see within range. Each creature in a 40-foot-radius sphere centered on each point you choose must make a Dexterity saving throw. The sphere spreads around corners. A creature takes 20d6 fire damage and 20d6 bludgeoning damage on a failed save, or half as much damage on a successful one. A creature in the area of more than one fiery burst is affected only once. The spell damages objects in the area and ignites flammable objects that aren't being worn or carried.",
    classes: ['sorcerer', 'wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'power-word-heal',
    name: 'Power Word Heal',
    level: 9,
    school: 'evocation',
    ritual: false,
    castingTime: '1 action',
    range: 'Touch',
    components: { verbal: true, somatic: true, material: false },
    duration: 'Instantaneous',
    concentration: false,
    description: "A wave of healing energy washes over the creature you touch. The target regains all its hit points. If the creature is charmed, frightened, paralyzed, or stunned, the condition ends. If the creature is prone, it can use its reaction to stand up. This spell has no effect on undead or constructs.",
    classes: ['bard'],
    source: 'srd-5.1',
  },
  {
    id: 'power-word-kill',
    name: 'Power Word Kill',
    level: 9,
    school: 'enchantment',
    ritual: false,
    castingTime: '1 action',
    range: '60 feet',
    components: { verbal: true, somatic: false, material: false },
    duration: 'Instantaneous',
    concentration: false,
    description: "You utter a word of power that can compel one creature you can see within range to die instantly. If the creature you choose has 100 hit points or fewer, it dies. Otherwise, the spell has no effect.",
    classes: ['bard', 'sorcerer', 'warlock', 'wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'prismatic-wall',
    name: 'Prismatic Wall',
    level: 9,
    school: 'abjuration',
    ritual: false,
    castingTime: '1 action',
    range: '60 feet',
    components: { verbal: true, somatic: true, material: false },
    duration: '10 minutes',
    concentration: false,
    description: "A shimmering, multicolored plane of light forms a vertical opaque wall—up to 90 feet long, 30 feet high, and 1 inch thick—centered on a point you can see within range. Alternatively, you can shape the wall into a sphere up to 30 feet in diameter centered on a point you choose within range. The wall remains in place for the duration. If you position the wall so that it passes through a space occupied by a creature, the spell fails, and your action and the spell slot are wasted. The wall sheds bright light out to a range of 100 feet and dim light for an additional 100 feet.",
    classes: ['wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'shapechange',
    name: 'Shapechange',
    level: 9,
    school: 'transmutation',
    ritual: false,
    castingTime: '1 action',
    range: 'Self',
    components: { verbal: true, somatic: true, material: true, materialDescription: 'a jade circlet worth at least 1,500 gp, which you must place on your head before you cast the spell', materialCost: 1500 },
    duration: '1 hour',
    concentration: true,
    description: "You assume the form of a different creature for the duration. The new form can be of any creature with a challenge rating equal to your level or lower. The creature can't be a construct or an undead, and you must have seen the sort of creature at least once. You transform into an average example of that creature, one without any class levels or the Spellcasting trait. Your game statistics are replaced by the statistics of the chosen creature, though you retain your alignment and Intelligence, Wisdom, and Charisma scores.",
    classes: ['druid', 'wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'storm-of-vengeance',
    name: 'Storm of Vengeance',
    level: 9,
    school: 'conjuration',
    ritual: false,
    castingTime: '1 action',
    range: 'Sight',
    components: { verbal: true, somatic: true, material: false },
    duration: '1 minute',
    concentration: true,
    description: "A churning storm cloud forms, centered on a point you can see and spreading to a radius of 360 feet. Lightning flashes in the area, thunder booms, and strong winds roar. Each creature under the cloud (no more than 5,000 feet beneath the cloud) when it appears must make a Constitution saving throw. On a failed save, a creature takes 2d6 thunder damage and becomes deafened for 5 minutes. Each round you maintain concentration on this spell, the storm produces different effects on your turn.",
    classes: ['druid'],
    source: 'srd-5.1',
  },
  {
    id: 'time-stop',
    name: 'Time Stop',
    level: 9,
    school: 'transmutation',
    ritual: false,
    castingTime: '1 action',
    range: 'Self',
    components: { verbal: true, somatic: false, material: false },
    duration: 'Instantaneous',
    concentration: false,
    description: "You briefly stop the flow of time for everyone but yourself. No time passes for other creatures, while you take 1d4 + 1 turns in a row, during which you can use actions and move as normal. This spell ends if one of the actions you use during this period, or any effects that you create during this period, affects a creature other than you or an object being worn or carried by someone other than you. In addition, the spell ends if you move to a place more than 1,000 feet from the location where you cast it.",
    classes: ['sorcerer', 'wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'true-polymorph',
    name: 'True Polymorph',
    level: 9,
    school: 'transmutation',
    ritual: false,
    castingTime: '1 action',
    range: '30 feet',
    components: { verbal: true, somatic: true, material: true, materialDescription: 'a drop of mercury, a dollop of gum arabic, and a wisp of smoke' },
    duration: '1 hour',
    concentration: true,
    description: "Choose one creature or nonmagical object that you can see within range. You transform the creature into a different creature, the creature into a nonmagical object, or the object into a creature (the object must be neither worn nor carried by another creature). The transformation lasts for the duration, or until the target drops to 0 hit points or dies. If you concentrate on this spell for the full duration, the transformation lasts until it is dispelled.",
    classes: ['bard', 'warlock', 'wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'true-resurrection',
    name: 'True Resurrection',
    level: 9,
    school: 'necromancy',
    ritual: false,
    castingTime: '1 hour',
    range: 'Touch',
    components: { verbal: true, somatic: true, material: true, materialDescription: 'a sprinkle of holy water and diamonds worth at least 25,000 gp, which the spell consumes', materialCost: 25000, materialConsumed: true },
    duration: 'Instantaneous',
    concentration: false,
    description: "You touch a creature that has been dead for no longer than 200 years and that died for any reason except old age. If the creature's soul is free and willing, the creature is restored to life with all its hit points. This spell closes all wounds, neutralizes any poison, cures all diseases, and lifts any curses affecting the creature when it died. The spell replaces damaged or missing organs and limbs. If the creature was undead, it is restored to its non-undead form. The spell can even provide a new body if the original no longer exists, in which case you must speak the creature's name.",
    classes: ['cleric', 'druid'],
    source: 'srd-5.1',
  },
  {
    id: 'weird',
    name: 'Weird',
    level: 9,
    school: 'illusion',
    ritual: false,
    castingTime: '1 action',
    range: '120 feet',
    components: { verbal: true, somatic: true, material: false },
    duration: '1 minute',
    concentration: true,
    description: "Drawing on the deepest fears of a group of creatures, you create illusory creatures in their minds, visible only to them. Each creature in a 30-foot-radius sphere centered on a point of your choice within range must make a Wisdom saving throw. On a failed save, a creature becomes frightened for the duration. The illusion calls on the creature's deepest fears, manifesting its worst nightmares as an implacable threat. At the end of each of the frightened creature's turns, it must succeed on a Wisdom saving throw or take 4d10 psychic damage. On a successful save, the spell ends for that creature.",
    classes: ['wizard'],
    source: 'srd-5.1',
  },
  {
    id: 'wish',
    name: 'Wish',
    level: 9,
    school: 'conjuration',
    ritual: false,
    castingTime: '1 action',
    range: 'Self',
    components: { verbal: true, somatic: false, material: false },
    duration: 'Instantaneous',
    concentration: false,
    description: "Wish is the mightiest spell a mortal creature can cast. By simply speaking aloud, you can alter the very foundations of reality in accord with your desires. The basic use of this spell is to duplicate any other spell of 8th level or lower. You don't need to meet any requirements in that spell, including costly components. The spell simply takes effect. Alternatively, you can create one of several effects: you can create one object of up to 25,000 gp in value, grant up to 10 creatures permanent resistance to a damage type, grant up to 10 creatures immunity to a spell or magical effect for 8 hours, undo a recent event, or force a reroll. You might be able to achieve something beyond the scope of these examples.",
    classes: ['sorcerer', 'wizard'],
    source: 'srd-5.1',
  },
];
